var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendarChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6619 19.336L8.01191 15.736L9.23691 14.486L11.6619 16.861L16.2869 12.236L17.5119 13.511L11.6619 19.336ZM5.56191 23.461C4.91108 23.461 4.35671 23.2321 3.89879 22.7742C3.44087 22.3162 3.21191 21.7619 3.21191 21.111V6.06103C3.21191 5.40332 3.44087 4.84306 3.89879 4.38026C4.35671 3.91744 4.91108 3.68603 5.56191 3.68603H6.96191V2.18604H9.01191V3.68603H16.6619V2.18604H18.7119V3.68603H20.1119C20.7696 3.68603 21.3299 3.91744 21.7927 4.38026C22.2555 4.84306 22.4869 5.40332 22.4869 6.06103V21.111C22.4869 21.7619 22.2555 22.3162 21.7927 22.7742C21.3299 23.2321 20.7696 23.461 20.1119 23.461H5.56191ZM5.56191 21.111H20.1119V10.586H5.56191V21.111Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarChecked);
export default __webpack_public_path__ + "static/media/calendar-checked.1127d91dbaf5d4730e5b83942373c5bc.svg";
export { ForwardRef as ReactComponent };